import api from "@/services/api";

export default {
  data() {
    return {
      selectedSubCompany: "",
      subCompanyOptions: [{ value: "", text: "ทั้งหมด" }],
    };
  },
  computed: {
    isWannasorn() {
      var comId = this.$store.state.Company.companyInfo.id;
      return [1000001, 1000002, 1000003].includes(comId);
    },
  },
  methods: {
    loadSubCompanyDropdown() {
      var self = this;
      var comId = self.$store.state.Company.companyInfo.id;
      var memberId = JSON.parse(localStorage.getItem("user")).id;
      api
        .get(
          "v1/companies/" + comId + "/members/" + memberId + "/sub-companies"
        )
        .then(function (memberScRes) {
          var memberScData = memberScRes.data || [];
          var isCompanyWide = false;
          var memberSubCompanies = [];
          for (var i = 0; i < memberScData.length; i++) {
            if (memberScData[i].subCompanyId === null) {
              isCompanyWide = true;
            } else {
              memberSubCompanies.push({
                value: memberScData[i].subCompanyId,
                text: memberScData[i].subCompanyName,
              });
            }
          }
          if (isCompanyWide) {
            api
              .get("v1/companies/" + comId + "/sub-companies")
              .then(function (allScRes) {
                var allScData = allScRes.data.data || allScRes.data || [];
                var options = [{ value: "", text: "ทั้งหมด" }];
                for (var j = 0; j < allScData.length; j++) {
                  options.push({
                    value: allScData[j].scId,
                    text: allScData[j].scName,
                  });
                }
                self.subCompanyOptions = options;
              });
          } else {
            if (memberSubCompanies.length === 1) {
              self.subCompanyOptions = memberSubCompanies;
              self.selectedSubCompany = memberSubCompanies[0].value;
            } else {
              self.subCompanyOptions = [{ value: "", text: "ทั้งหมด" }].concat(
                memberSubCompanies
              );
            }
          }
        });
    },
  },
};
